import { useEffect } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import Banner from '../components/Banner'
import Platform from '../components/Platform'
import { useLocation, useNavigate } from 'react-router-dom'

import bgkey from './../assets/bg_key.png'
import key_1 from './../assets/fluent_cloud-flow-20-filled.png'
import key_2 from './../assets/icon-park-solid_alarm.png'
import key_3 from './../assets/tdesign_task-filled.png'
import key_4 from './../assets/fluent_brain-circuit-28-filled.png'
import bg_bottom from './../assets/150896785_10515253_1.png'
import bg_top from './../assets/150896785_10515253_2.png'
import finding_1 from './../assets/fluent_cloud-swap-24-regular.png'
import finding_2 from './../assets/lsicon_database-outline.png'
import finding_3 from './../assets/mdi_cloud-plus-outline.png'
import finding_4 from './../assets/fluent_organization-20-regular.png'
import finding_5 from './../assets/tabler_cloud-x.png'
import finding_6 from './../assets/tabler_cloud-up.png'
import finding_7 from './../assets/mingcute_code-line.png'
import finding_8 from './../assets/mdi_account-star-outline.png'
import different_1 from './../assets/Unlimited_Users.png'
import different_2 from './../assets/Group_1171275495.png'
import different_3 from './../assets/All_in_One.png'
import different_4 from './../assets/Group_11712754956.png'
import risk_1 from './../assets/streamline_bug-antivirus-shield-remix.png'
import risk_2 from './../assets/material-symbols_security.png'
import risk_3 from './../assets/material-symbols_lock.png'
import risk_4 from './../assets/mdi_key.png'
import risk_5 from './../assets/mingcute_loading-3-fill.png'
import risk_6 from './../assets/Frame_1171277331.png'
import orca_logo from './../assets/orca.png'
import DemoForm from '../components/DemoForm'
import EventList from '../components/EventList'

const Home = () => {
  const { hash } = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [hash]);

  return(
    <div className='wrap-hidden'>
      
      <Banner/>
      <div className='mt-5 pb-5 pt-5'
        style={{
          backgroundImage: `url(${bgkey})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='header text-center'>Key Challenges in <span className="text-brand-secondary">Cloud Security</span></div>
            <p className='mt-4 text-justify text-center'><strong>Even the Cloud Has Shadows.</strong></p>
            <p className='text-justify text-center'>Behind speed and scalability lies complexity, fragmentation, and risk.</p>
            <p className='text-justify text-center'>Today’s organizations face evolving threats, mounting compliance pressure, and alert overload all while chasing innovation.</p>
            <p className='text-justify text-center'>The challenge isn’t just protecting infrastructure it’s protecting everything, everywhere, all at once.</p>
          </AnimationOnScroll>

          <div className='mt-5 pt-5 mb-5 mb-5'>
            <Row>
              <Col md={3} xs={6} className="mt-3">
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} offset={100}>
                  <div className='key-card'>
                    <div className='header bg-main'>
                      <div className='icon-wrapper'>
                        <img src={key_1} alt=""/>
                      </div>
                    </div>
                    <div className='body text-center'>
                      <strong>Cloud Environments Never Stand Still</strong>
                    </div>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className="mt-3">
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={100}>
                  <div className='key-card'>
                    <div className='header bg-main-secondary'>
                      <div className='icon-wrapper'>
                        <img src={key_2} alt=""/>
                      </div>
                    </div>
                    <div className='body text-center'>
                      <strong>Too Many Risks, Too Little Prioritization</strong>
                    </div>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className="mt-3">
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={200}>
                  <div className='key-card'>
                    <div className='header bg-main'>
                      <div className='icon-wrapper'>
                        <img src={key_3} alt=""/>
                      </div>
                    </div>
                    <div className='body text-center'>
                      <strong>Compliance Isn’t Optional Or Easy</strong>
                    </div>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className="mt-3">
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={200}>
                  <div className='key-card'>
                    <div className='header bg-main-secondary'>
                      <div className='icon-wrapper'>
                        <img src={key_4} alt=""/>
                      </div>
                    </div>
                    <div className='body text-center'>
                      <strong>The Talent Gap Is Real and Costly</strong>
                    </div>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${bg_bottom})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='header text-center'>Key Findings in <span className="text-brand-secondary">Cloud Security</span></div>
            <p className='mt-4 text-justify text-center'><strong>Hard Truths You Can’t Ignore.</strong></p>
            <p className='text-justify text-center'>In an era where speed beats control, most organizations are flying blind and attackers know it.</p>
            <p className='text-justify text-center'>The data below isn’t just shocking it’s your wake-up call. These aren’t isolated incidents; they’re patterns repeating across industries, platforms, and teams.</p>
          </AnimationOnScroll>

          <div className='mt-5 mb-5 mb-5 findings-container'>
            <Row className='findng-card'>
                <Col md={3} xs={6} className='finding-card-box'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} offset={100}>
                    <div className='pt-5 pb-5 ps-3 pe-3'>
                      <div className='d-flex flex-row align-items-center gap-2'>
                        <img src={finding_1} style={{width:"50px"}} alt=""/>
                        <div className='flex-fill'>
                          <h2 className='text-brand extra-bold'>13%</h2>
                        </div>
                      </div>
                      <p className='mt-3'><strong>of organizations have a single cloud asset that creates 1,000+ attack paths</strong></p>
                      <p className='mt-3'>One misstep can expose your entire ecosystem.</p>
                    </div>
                  </AnimationOnScroll>
                </Col>
                <Col md={3} xs={6} className='finding-card-box'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={50} animatePreScroll={true} offset={100}>
                    <div className='pt-5 pb-5 ps-3 pe-3'>
                      <div className='d-flex flex-row align-items-center gap-2'>
                        <img src={finding_2} style={{width:"50px"}} alt=""/>
                        <div className='flex-fill'>
                          <h2 className='text-brand extra-bold'>38%</h2>
                        </div>
                      </div>
                      <p className='mt-3'><strong>store sensitive data in public-facing databases</strong></p>
                      <p className='mt-3'>Because what’s better than handing attackers a free buffet?</p>
                    </div>
                  </AnimationOnScroll>
                </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_3} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>115</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>vulnerabilities per cloud asset, on average</strong></p>
                    <p className='mt-3'>That’s not visibility. That’s chaos disguised as infrastructure.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={150} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_4} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>58%</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>of orgs still have vulnerabilities older than 20 years</strong></p>
                    <p className='mt-3'>Yes, the same ones from the Windows XP era.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={0} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_5} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>32%</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>of cloud assets are in a neglected state</strong></p>
                    <p className='mt-3'>If attackers don’t have to work hard, why would they?</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={50} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_6} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>76%</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>expose public-facing assets that enable lateral movement</strong></p>
                    <p className='mt-3'>One foot in, and they’re everywhere.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_7} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>85%</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>tore plaintext secrets in source code</strong></p>
                    <p className='mt-3'>“Hardcoded” means “easily stolen” in hacker language.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={6} className='finding-card-box'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={150} animatePreScroll={true} offset={100}>
                  <div className='pt-5 pb-5 ps-3 pe-3'>
                    <div className='d-flex flex-row align-items-center gap-2'>
                      <img src={finding_8} style={{width:"50px"}} alt=""/>
                      <div className='flex-fill'>
                        <h2 className='text-brand extra-bold'>93%</h2>
                      </div>
                    </div>
                    <p className='mt-3'><strong>have over-privileged Kubernetes accounts</strong></p>
                    <p className='mt-3'>Your containers deserve better security than your interns.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div className='pt-5'
        style={{
          backgroundImage: `url(${bg_top})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "100% auto"
        }}
      >
        <Container className='mt-5 pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='header text-center mt-5'>Why Choose <span className="text-brand-secondary">Siberwander</span></div>
            <p className='mt-4 text-justify text-center'><strong>Smart. Secure. Seamless.</strong></p>
            <p className='text-justify text-center'>Siberwander is more than just a cybersecurity provider. We are your partner in building digital resilience.</p>
            <p className='text-justify text-center'>Our solutions are designed to move as fast as your business, scale as wide as your ambitions, and adapt as quickly as the threats around you.</p>
            <br/>
            <p className='text-justify text-center'>We bring world-class security technology, expert-backed services, and hands-on support together in one integrated ecosystem. Whether you're just starting your cloud journey or protecting complex, multi-cloud environments, Siberwander helps you stay ahead with clarity, confidence, and control.</p>
            <br/>
            <p className='text-justify text-center'>From agentless deployment to 24/7 managed protection, we simplify cloud security without cutting corners so you can focus on growing your business while we keep it safe.</p>
          </AnimationOnScroll>
        </Container>

        <Container className='pt-5 pb-5'>
          <div className='card-shadow'>
            <Container className='pt-5 pb-5'>
              <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
                <div className='header text-center'>What Makes Us <span className="text-brand-secondary">Different</span></div>
                <p className='mt-4 text-justify text-center'><strong>Modern Cloud Security, Engineered for Velocity and Clarity.</strong></p>
              </AnimationOnScroll>
            </Container>
            <div className='make-us ps-5 pe-5 pb-5'>
              <Row className='mt-4'>
                <Col md={6} xs={12} className='mb-5'>
                  <div className='d-flex flex-row gap-3'>
                    <img src={different_1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='flex-fill'>
                      <strong>Instant Agentless Deployment</strong>
                      <p className='mt-3'>No installs. No downtime. No excuses. Spin up full cloud coverage in minutes — with zero software agents and zero infrastructure friction.</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} xs={12} className='mb-5'>
                  <div className='d-flex flex-row gap-3'>
                    <img src={different_2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='flex-fill'>
                      <strong>Complete Cloud Visibility</strong>
                      <p className='mt-3'>100% Asset awareness. Zero blind spots. See everything across your cloud, VMs, containers and serverless functions with a single, unified view. Gain real-time, contextual visibility into every workload, every layer, every risk without deploying a single agent.</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} xs={12} className='mb-5'>
                  <div className='d-flex flex-row gap-3'>
                    <img src={different_3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='flex-fill'>
                      <strong>All-in-One Security, Built to Scale</strong>
                      <p className='mt-3'>One platform. Every layer protected. From posture management to API shielding, we combine deep detection, compliance assurance, and intelligent risk prioritization in a single cloud-native console.</p>
                      <br/>
                      <p>Includes:</p>
                      <ul>
                        <li>Cloud Security Posture Management (CSPM)</li>
                        <li>Cloud Infrastructure Entitlement Management (CIEM)</li>
                        <li>Cloud Workload Protection (CWP)</li>
                        <li>Kubernetes Security Posture Management (KSPM)</li>
                        <li>Shift Left Security</li>
                        <li>Data Security Posture Management (DSPM)</li>
                        <li>Cloud Detection & Response (CDR)</li>
                        <li>Network/API Security</li>
                        <li>Built in Compliance Best Practice & Standard Regulations</li>
                        <li>AI Security Posture Management (AI-SPM)</li>
                        <li>Cloud-to-Dev</li>
                      </ul>
                    </div>
                  </div>
                </Col>

                <Col md={6} xs={12} className='mb-5'>
                  <div className='d-flex flex-row gap-3'>
                    <img src={different_4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='flex-fill'>
                      <strong>24/7 Managed Cloud Security</strong>
                      <p className='mt-3'>We never sleep, so you can. Our elite security ops team delivers always-on threat monitoring, rapid incident response, and proactive compliance support so your business keeps moving, securely.</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>

      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center mt-5'>Risk Covered by <span className="text-brand-secondary">Siberwander</span></div>
          <p className='mt-4 text-justify text-center'><strong>Stay Ahead of Threats Before They Become Breaches.</strong></p>
          <p className='text-justify text-center'>Siberwander helps you detect, prioritize, and respond to the most critical cloud risks long before they turn into costly incidents.</p>
          <p className='text-justify text-center'>From hidden misconfigurations to exposed sensitive data, we cover the full spectrum of cloud threats across infrastructure, workloads, users, APIs, and more.</p>
          <br/>
          <p className='text-justify text-center'>By combining deep visibility with smart automation, Siberwander doesn’t just show you what’s wrong we help you fix what matters most, fast.</p>
        </AnimationOnScroll>

        <div className='card-shadow mt-4 bg-main-secondary-light'>
          <div className='category ps-5 pe-5 pt-4'>
            <Row>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Malware</strong></div>
                    <p className='text-center mt-2'>Uncover malicious payloads with advanced signature intelligence and behavior-based scanning in real time.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Vulnerability Discovery</strong></div>
                    <p className='text-center mt-2'>Expose systemic weaknesses in operating systems, applications, and open-source libraries before attackers do.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Insecure Configurations</strong></div>
                    <p className='text-center mt-2'>Detect misconfigurations like open buckets and outdated cipher sets the silent killers of cloud security.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Authentication Risks</strong></div>
                    <p className='text-center mt-2'>Identify weak credentials, leaked passwords, and over-permissioned identities that could open the door to breaches.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_5} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Sensitive Data Exposure</strong></div>
                    <p className='text-center mt-2'>Safeguard critical assets like emails, user records, and customer PII with precision-layered data security.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={4} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={risk_6} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Lateral Movement Defense</strong></div>
                    <p className='text-center mt-2'>Stop intruders from pivoting inside your cloud by detecting insecure keys, flat networks, and segmentation gaps.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
          <div className='subheader text-center mt-2 mb-4'><span className="text-brand">And More</span></div>
        </div>
      </Container>
      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center mt-5'><span className="text-brand-secondary">Siberwander</span> Cloud Security Platform</div>
          <div className='mt-4 d-flex flex-row justify-content-center align-items-center gap-3'>
            <p>Powered by</p>
            <img src={orca_logo} style={{height:"30px"}} alt=""/>
          </div>
          <p className='mt-4 text-justify text-center'>One platform to protect everything in your cloud fast, simple, and agentless.</p>
        </AnimationOnScroll>

        <Platform/>
        
      </Container>
      
      <Container className='pt-5 pb-5' id="events">
        <EventList showTitle={true} limit={3} type="active"/>
        <div className='bg-light py-5'>
          <Container>
            <Row>
              <Col xs={12}>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
                  <div className='text-center mb-4'>
                    <h3>Other Upcoming Events</h3>
                    <p className='text-muted'>Discover more cybersecurity events and workshops</p>
                  </div>

                  <div className="text-center">
                    <Button variant="outline-primary" onClick={() => navigate('/events')}>
                      View All Events
                    </Button>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      
      <Container className='pt-5 pb-5' id="demo-form">
        <DemoForm/>
      </Container>
    </div>
  )
}

export default Home